import {
  BooleanField,
  Datagrid,
  FunctionField,
  List,
  SelectField,
  TextField,
} from 'react-admin';
import { staffMarketsSummary, useAllStaffMarkets } from './StaffMarkets';
import { CallbackRotaCard } from './CallbackRota';
import { formatStaffPhone } from './staffPhone';

const roleChoices = [
  { id: 'admin', name: 'Admin' },
  { id: 'director', name: 'Director' },
  { id: 'coordinator', name: 'Coordinator' },
  { id: 'staff', name: 'Staff' },
  { id: 'operations', name: 'Operations' },
  { id: 'public_user', name: 'Public User' },
];

export const ProfilesList = () => {
  const markets = useAllStaffMarkets();
  return (
    <>
      <List>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="name" />
          <TextField source="email" />
          <SelectField source="role" choices={roleChoices} />
          <BooleanField source="active" />
          <TextField source="initials" />
          <TextField source="slack_user_id" label="Slack ID" />
          <TextField source="aircall_user_id" label="Aircall ID" />
          <FunctionField
            label="Phone"
            render={(r: { phone?: string | null }) => formatStaffPhone(r.phone)}
          />
          <FunctionField
            label="Markets"
            render={(r: { id: string }) =>
              staffMarketsSummary(markets.get(String(r.id)))
            }
          />
        </Datagrid>
      </List>
      <CallbackRotaCard />
    </>
  );
};
